var map = {
	"./banner-bg.png": 2629,
	"./burn-wallet-logo.png": 71,
	"./divider.png": 3670,
	"./flag.png": 2420,
	"./icon-approved-signal.svg": 8850,
	"./icon-contact-request.svg": 8535,
	"./icon-dashboard.svg": 4563,
	"./icon-dollar.svg": 471,
	"./icon-fee-management.svg": 6213,
	"./icon-filter.svg": 426,
	"./icon-logout.svg": 3347,
	"./icon-manage-roles.svg": 1398,
	"./icon-pending-request.svg": 4231,
	"./icon-refund-request.svg": 8827,
	"./icon-settings.svg": 2079,
	"./icon-transaction-filled.svg": 8432,
	"./icon-transaction.svg": 8448,
	"./icon-users.svg": 404,
	"./profile.png": 1989,
	"./remember-icon.svg": 9164,
	"./sign-in-bg.png": 1310
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;